import React from 'react';
// import styled from 'styled-components/macro';
// import PlayerContext from '@mirinae/lessons/modules/contexts/player';
// import LessonCard from '@mirinae/lessons/components/card/LessonCard';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
// import httpAPI from '@mirinae/lessons/modules/apis/http';
// import { apiPaths } from '@mirinae/shared/defines/paths';

const LessonCardElement = ({ element }) => {
    // const player = useContext(PlayerContext);

    return <Element element={element}>LessonCard not yet implemented</Element>;

//     useEffect(() => {
//         httpAPI('', apiPaths.lesson, { data: { lessonID } })
//             .then(response => {
//                 setGlobal(prev => { ...prev, currentLesson: response.data.lesson });
//             });
//     }, []);
//
//     return (
//         <Element element={element}>
//             <LessonCard
//                 data={{
//                     levelTitle: lesson.lessonNode.levelTitle,
//                     listingLabel: lesson.lessonNode.listingLabel,
//                     link: lessonLink(lesson),
//                     title: lesson.lessonNode.startPageTitle || lesson.title,
//                     sections: lesson.lessonNode.sections,
//                     lessonObject: lesson,
//                 }}
//                 progress={lesson.progress}
//                 state={lesson.lessonTracker ? lesson.lessonTracker.state : 'start'}
//                 theme={theme}
//             />
//         </Element>
//     );
};

export default LessonCardElement;
